import { ValidatorFn, AbstractControl, FormGroup } from '@angular/forms';

/**
 * The  latitude or longitude should always lie in given range
 * @param min - minimum value (can be negative number also)
 * @param max - maximum value
 */
export function latLangRange(min: number, max: number): ValidatorFn {
  return (c: AbstractControl): { [key: string]: boolean } | null => {
    
    if (c.value !== null &&
        (isNaN(c.value)  || c.value < min || c.value > max) ){
      return { range: true };
    }
    return null;
  };
}
export function latLangDMSRange(min: number, max: number): ValidatorFn {
  return (c: AbstractControl): { [key: string]: boolean } | null => {
    if(c.value !=null){
      const {degree,minutes,seconds} = c.value;
      const nullCheck = (degree !== null && minutes !== null && seconds !== null);
      const isNan = isNaN(degree) || isNaN(minutes) || isNaN(seconds);
  
      const minCheck = (degree <= min && (minutes >= 0 || seconds >= 0));
      const maxCheck = (degree >= max && (minutes >= 0 || seconds >= 0));
      if (nullCheck && (isNan || minCheck || maxCheck)){
        return { range: true };
      }
    }
    return null;
  };
}
export function latLangDMRange(min: number, max: number): ValidatorFn {
  return (c: AbstractControl): { [key: string]: boolean } | null => {
    if(c.value !=null){
      const {degree,minutes} = c.value;
      const nullCheck = (degree !== null && minutes !== null);
      const isNan = isNaN(degree) || isNaN(minutes);
  
      const minCheck = (degree <= min && minutes >= 0 );
      const maxCheck = (degree >= max && minutes >= 0 );
      if (nullCheck && (isNan || minCheck || maxCheck)){
        return { range: true };
      }
    }
    return null;
  };
}
